<div class="progress-loader" [hidden]="!loading">
     <!-- <app-spinner-wild></app-spinner-wild> -->
     <app-spinner-fa></app-spinner-fa>
</div>

